// This file's entirely about extending native functionality.
/* eslint-disable no-extend-native */

import arrayIncludes from 'core-js/features/array/virtual/includes';
import arrayFind from 'core-js/features/array/virtual/find';
import arrayFindIndex from 'core-js/features/array/virtual/find-index';

Array.prototype.includes = Array.prototype.includes || arrayIncludes;
Array.prototype.find = Array.prototype.find || arrayFind;
Array.prototype.findIndex = Array.prototype.findIndex || arrayFindIndex;
